export default function searchTermCleanser(string) {
  return string
    .toLowerCase()
    .trim()
    .replace(/\s\s+/g, " ")
    .replace(/<\/?[^>]+(>|$)|\t/g, "");
}
